import { render, staticRenderFns } from "./BeneficiariesFilter.vue?vue&type=template&id=75a0460d&"
import script from "./BeneficiariesFilter.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports